import React from 'react';
import '../CSS/Profile/KirbyGodseyProfile.css';

const KirbyGodseyProfile: React.FC = () => {
  const imagePath = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/r-kirby-godsey-image.png`;
  const linkedInIcon = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Icons/linkedin-blue-icon.svg`;

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div className="profile-picture-container">
          <img 
            src={imagePath}
            alt="R. Kirby Godsey"
            className="profile-picture"
          />
        </div>
      </div>
      <div className="profile-content">
        <h1 className="profile-name">R. Kirby Godsey, PhD</h1>
        <div className="profile-title-container">
          <p className="profile-title">Board Member</p>
          <img 
            src={linkedInIcon}
            alt="LinkedIn"
            className="profile-linkedin-icon"
          />
        </div>
        <div className="profile-desc">
          <p>
            <strong>R. Kirby Godsey, Ph.D.</strong> served 27 years as President and CEO of Mercer University, a private, doctoral university with high research activity (R2). In 2006, he was honored with the office of University Chancellor and Professor, which he continues to hold. Under his leadership, the 187-year-old institution experienced significant growth in size and prominence. He established seven of the university's eleven schools and colleges, including schools of business, engineering, and medicine; an academic press; a performing arts center; and an engineering research center. He also led the merger of Georgia Baptist College of Nursing with Mercer and developed academic partnerships across the state and globally.
          </p>
          <p>
            Dr. Godsey is a board member and former board chair of Myers McRae.
          </p>
          <p>
            He has been repeatedly recognized as one of Georgia's most influential leaders by Georgia Trend magazine. He was named the Council for Advancement and Support of Education (CASE) III Chief Executive Officer of the Year in 2002 and was awarded the Distinguished Leadership Award by the Southern Association of Colleges and Schools (SACS) for his outstanding work on accreditation standards.
          </p>
          <p>
            Dr. Godsey is a member of the Executive Council of the College Commission for the Southern Association of Colleges and Schools (SACS) and a member of the Executive Committee of the National Association of Independent Colleges and Universities.
          </p>
          <p>
            Before becoming president of Mercer, he served as executive vice president and dean of the university's College of Liberal Arts. Previously, he served as vice president and dean of Averett College in Virginia, was a Danforth Associate with the Danforth Foundation, and served as professor of philosophy and religion at Judson College in Alabama.
          </p>
          <p>
            Dr. Godsey earned his bachelor's degree from Samford University, Master of Divinity and Doctor of Theology degrees from New Orleans Baptist Theological Seminary, Master of Arts in Philosophy from the University of Alabama, and Ph.D. in Philosophy from Tulane University. He is the recipient of honorary doctorates from The University of South Carolina, Samford University, Campbell University, and Averett University.
          </p>
          <p>
            He is the author of six books, including The God Particle, published in 2016, and has written numerous articles for professional journals. He is a frequent lecturer and a consultant on leadership and higher education administration, and serves on a number of civic and professional boards and committees.
          </p>
        </div>
      </div>
    </div>
  );
};

export default KirbyGodseyProfile;

